import { Store } from 'flummox';
import Immutable from 'immutable';
import localStorage from 'localStorage';
import DiffJson from 'diff-json';

function fromJSOrdered(js) {
  return typeof js !== 'object' || js === null ? js :
    Array.isArray(js) ?
      Immutable.Seq(js).map(fromJSOrdered).toList() :
      Immutable.Seq(js).map(fromJSOrdered).toOrderedMap();
}

export default class SectionStore extends Store {
  constructor(flux, fileName, localStorageSave) {
    super();
    this.localStorageKey = fileName;

    const sectionActions = flux.getActions('sections');
    this.register(sectionActions.addSection, this.newSection);
    this.register(sectionActions.updateSection, this.updateSection);
    this.register(sectionActions.updateSectionProperties, this.updateSectionProperties);
    this.register(sectionActions.saveState, this.saveState);

    if (localStorage.getItem(this.localStorageKey) && localStorageSave) {
      let savedState = JSON.parse(localStorage.getItem(this.localStorageKey));

      this.stateInLocalStorage = Immutable.fromJS({sections:
                                  fromJSOrdered(savedState.sections)});
    } else {
      this.stateInLocalStorage = false;
    }

    this.localStorageSave = localStorageSave;
    localStorage.setItem("localStorageSave", localStorageSave);

    this.state = Immutable.fromJS({sections: Immutable.OrderedMap(),
                                   previousSections: Immutable.OrderedMap(),
                                   isSaved: true,
                                   fileName: this.localStorageKey});
  }
  static assignState(oldState, newState) {
    if (oldState === undefined || oldState === null) {
      const ImmutableMap = newState.constructor;
      oldState = new ImmutableMap();
    }

    let returnState = oldState.merge(oldState, newState);

    if (localStorage.getItem("localStorageSave")) {
      localStorage.setItem(returnState.get('fileName'), JSON.stringify(returnState.toJS()));
    }

    return returnState;
  }

  newSection({path, data}) {
    let elementPath = path.split(" ");

    elementPath.splice(0,0, "sections");

    if (elementPath.length > 2) {
      elementPath.splice(2, 0, "sections");
    }

    if (this.stateInLocalStorage && this.localStorageSave) {

      let diffs = DiffJson.diff(this.stateInLocalStorage.getIn(elementPath).toJS(),
                                data);

      let isSaved = ((this.state.get('isSaved')) && diffs.length > 0) ? false
                                                                      : this.state.get('isSaved');

      if (this.stateInLocalStorage.getIn(elementPath))
      this.setState(this.state.set("previousSections", this.state.get('sections'))
                              .setIn(elementPath, this.stateInLocalStorage.getIn(elementPath))
                              .set("isSaved", isSaved));

    } else {
      this.setState(this.state.set("previousSections", this.state.get('sections'))
                              .setIn(elementPath, Immutable.fromJS(data)));
    }
  }

  updateSection({path, data, save}) {
    let elementPath = path.split(" ");

    elementPath.splice(0,0, "sections");

    if (elementPath.length > 2) {
      elementPath.splice(2, 0, "sections");
    }

    let isSaved = (!this.state.get('isSaved') || save) ? false : true;

    this.setState(this.state.set("previousSections", this.state.get('sections'))
                            .setIn(elementPath, Immutable.fromJS(data))
                            .set("isSaved", isSaved));
  }

  updateSectionProperties({path, data}) {
    let elementPath = path.split(" ");

    elementPath.splice(0,0, "sections");

    if (elementPath.length > 2) {
      elementPath.splice(2, 0, "sections");
    }

    elementPath.push("properties");

    this.setState(this.state.set("previousSections", this.state.get('sections'))
                            .setIn(elementPath, Immutable.fromJS(data))
                            .set("isSaved", false));

  }

  saveState() {
    this.setState(this.state.set("isSaved", true));
    localStorage.removeItem(this.localStorageKey);
  }
}



// WEBPACK FOOTER //
// ./src/flux/SectionStore.js